/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SwapRequestStatusResponseItem } from './swap-request-status-response-item';


export interface SwapRequestResponseItem { 
    id: string;
    currencyTickerTo: string;
    currencyNameTo: string;
    chainNameTo: string;
    currencyTickerFrom: string;
    currencyNameFrom: string;
    chainNameFrom: string;
    accountName: string;
    amountFrom: number;
    amountTo: number;
    commission: number;
    status: SwapRequestStatusResponseItem;
    createdDate: string;
}

